<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.user-detail')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-5">
          <!--          <b-alert show variant="dark" class="pt-5">-->
          <h3><span style="text-decoration: underline; font-weight : bolder;">사업주의 내부 직원에게만 권한을 부여</span>할 수 있으며 , 이를
            위반하여 내부 직원 외에 권한을 부여할 경우 ,
            개인정보보호법상 동의없는 개인정보 제3자 제공에 해당하여
            5년 이하의 징역 또는 5천 만원 이하의 벌금형에 처할 수 있습니다.
            <br/><br/>
            또한 내부 직원의 권한 관리에 소홀하거나 관련 법령상의 개인정보보호 의무를 준수 하지 않아 회원에게 피해가 발생하거나 발생 할 가능성이 있을 경우 권한이 회수될수 있으며 , 이 경우에도
            개인정보보호법 위반으로
            처벌될 수 있습니다.<br/><br/>
            <b-form-checkbox style="color:#c11314;" v-model="isAgree" :checked="true" :unchecked-value="false">주의 사항을 확인
              하였으며 이에 동의 합니다.
            </b-form-checkbox>
          </h3>
          <!--          </b-alert>-->
        </b-card>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-row>
            <b-colxx xxs="12" lg="6" aling="center">
              <b-form>
                <b-form-group label-cols="2" horizontal label="아이디">
                  <b-form-input class="modalFontSize" v-model="username" :plaintext="true"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="이름">
                  <b-form-input class="modalFontSize" v-model="fullName" :plaintext="true"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="휴대폰">
                  <b-form-input class="modalFontSize" v-model="phoneNumber" :plaintext="true"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="이메일">
                  <b-form-input class="modalFontSize" v-model="email" :plaintext="true"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="권한">
                  <b-form-input class="modalFontSize" :value="gradeOption.find(x => x.value === userRole) != null ? gradeOption.find(x => x.value === userRole).label : ''" :plaintext="true"></b-form-input>
<!--                  <span class="modalFontSize">{{-->
<!--                      gradeOption.find(x => x.value === userRole) != null ? gradeOption.find(x => x.value === userRole).label : ''-->
<!--                    }}</span>-->
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="관리매장">
                  <!--하이테이블 ui개선작업의 일환으로 div=> template로 변경 -->
                  <template v-if="!registerMode">
                    <b-form-input class="modalFontSize" :value="storeOptions.find(x => x.value === storeCode) != null ? storeOptions.find(x => x.value === storeCode).text : '' " :plaintext="true"></b-form-input>
<!--                    <span class="modalFontSize">-->
<!--                      {{storeOptions.find(x => x.value === storeCode) != null ? storeOptions.find(x => x.value === storeCode).text : '' }}-->
<!--                    </span>-->
                  </template>
                  <b-form-select v-else v-model="storeCode" :options="storeOptions" size="sm"></b-form-select>
                  <!--                  <b-form-select v-model="storeCode" :options="storeOptions" size="sm"></b-form-select>-->
                </b-form-group>


<!--                <b-button @click="registerRole" variant="success default"> {{ registerMode ? '승인' : '저장' }}</b-button>-->
              </b-form>

            </b-colxx>
          </b-row>
          <div class="text-center mt-3">
                <b-button @click="onCancel" variant="outline-primary" v-if="this.$route.fullPath.includes('manager-detail')">취소</b-button>
                  <b-button v-if="registerMode" @click="registerRole" variant="success">승인</b-button>
                  <b-button v-if="username != 'admin'" @click="unRegister" variant="primary">
                    {{ registerMode ? '불가' : '삭제' }}
                  </b-button>
                </div>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>

import {
  mapGetters,
  mapActions
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
  validationMixin
} from "vuelidate";
import api from '../../constants/api'

const {
  required,
  maxLength,
  minLength,
  numeric,
  email
} = require("vuelidate/lib/validators");


export default {
  components: {
    'v-select': vSelect,
  },
  props: [],
  mixins: [validationMixin],
  validations: {
    username: {
      required
    },
    fullName: {
      required
    },
    phoneNumber: {
      required,
      numeric
    }

  },
  data() {
    return {
      registerMode: false,
      username: this.$route.params.id,
      fullName: '테스트',
      phoneNumber: '010-4193-5290',
      email: 'enjoyhyoeun@naver.com',
      userRole: null,
      userRoleSet: null,
      storeCode: null,
      isAgree: false,
      gradeOption: [
        {label: '마스터', value: 'BRAND_ADMIN'},
        // {label: '브랜드 관리자', value: 'BRAND_MANAGER'},
        // {label: '매장 운영자', value: 'STORE_OWNER'},
        {label: '스토어 스탭', value: 'STORE_MANAGER'}
      ],
      storeOptions: []
    }
  },
  computed: {
    ...mapGetters(['info', 'currentUser', 'siteName'])
  },
  mounted() {
    console.log(this.$route.fullPath.includes('manager-detail'))
    let pathArray = this.$route.path.split('/')
    if(pathArray[3] === "register-detail") {
      this.registerMode = true
    } else {
      this.registerMode = false
    }
    this.storeInfo()
    this.loadData()
  },
  methods: {
    onCancel() {
      this.$router.back()
    },

    //관리자정보조회
    loadData() {
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.info)
      const params = {
        username: this.username
      }

      this.$http.get(reqURL, {
        params: params,
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {

          let _data = res.data.data
          this.username = _data.username
          this.fullName = _data.fullName
          this.phoneNumber = _data.phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
          this.email = _data.email

          if(this.registerMode) {
            this.userRole = this.gradeOption.find(x => x.value === 'STORE_MANAGER').value
          } else {
            this.userRole = this.gradeOption.find(x => x.value === _data.userRole).value
          }

          this.storeCode = _data.storeCode

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },

    //사이트 내 매장 코드 리스트 검색
    async storeInfo() {
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCode)

      await this.$http.get(reqURL, {}).then(res => {
        if(res.data.code === "OK") {
          const data = res.data.data
          if(data.length === 0) {
            alert('매장관리 메뉴를 통해 매장부터 등록해주세요')
            this.$router.back()
            return false
          }

          // this.storeOptions.push({label: "매장없음", value: 'none'})

          for(let i = 0; i < data.length; i++) {
            const store = data[i];
            this.storeOptions.push({text: store.storeName, value: store.storeCode})
          }


          this.isLoad = true

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },


    //관리자 권한 부여
    registerRole() {

      const reg = this.registerMode

      if(this.username == null || this.username == undefined) {
        alert("권한을 부여받을 관리자 ID를 입력하세요")
        return
      }

      if(this.isAgree === false) {
        alert('개인정보 주의사항 동의를 해주세요.')
      } else if((this.userRole == "STORE_OWNER" || this.userRole == "STORE_MANAGER") && this.storeCode === null) {
        alert('관리매장을 선택해주세요.')
      } else {
        // userRole 이 STORE_MANAGER, STORE_OWNER 일 경우 필수 입력
        const storeCode = this.userRole == "STORE_OWNER" || this.userRole == "STORE_MANAGER" ? this.storeCode : null


        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.grantRole)
        const params = {
          username: this.username,
          userRole: this.userRole,
          storeCode: storeCode
        }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            alert('적용되었습니다.')

            if(reg) {
              this.$router.push(`/${this.siteName}/manager/register-new-manager`);
            } else {
              this.$router.push(`/${this.siteName}/manager/manager-list`);
            }


          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })

      }
    },
    unRegister() {
      if(this.username == null || this.username == undefined) {
        alert("거절할 사용자 ID가 없습니다.")
        return
      }
      const reg = this.registerMode
      let msg = '해당 ID를 삭제하시겠습니까?'
      if(reg) {
        msg = '해당 ID를 승인 거절 하시겠습니까?'
      }
      if(confirm(msg)) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.unregister)
        const params = {
          username: this.username
        }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            alert('적용하였습니다.')

            if(reg) {
              this.$router.push(`/${this.siteName}/manager/register-new-manager`);
            } else {
              this.$router.push(`/${this.siteName}/manager/manager-list`);
            }

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },
  }
  , watch: {
    storeOptions(val) {
      console.log(val);

    }
  }
}
</script>
<style>
.modalFontSize {
  font-size: 0.9rem !important;
}

</style>
